module.exports = __webpack_public_path__ + "static/img/pp-03.aabef78f.jpg";